export const switchTheme = {
  baseStyle: {
    container: {},
    thumb: {},
    track: {
      bg: 'reno.red50',
      _focus: {
        boxShadow: 'base', // remove focus red outline
      },
      _checked: {
        bg: 'secondaryColor',
      },
    },
  },

  variants: {
    summaryPage: {
      container: {},
      thumb: {},
      track: {
        bg: 'unactiveColor',
        _checked: {
          bg: 'secondaryColor',
        },
      },
    },
  },
};
